// extracted by mini-css-extract-plugin
export var icon = "_88-1";
export var subtext = "_88-0";